// Backend contract:
// POST /auth/login
// Body: { username: string, password: string }
// Success (200): sets HttpOnly JWT cookie
// Failure (401): invalid credentials

import { BASE_URL, STORAGE_SESSION_ACTIVE, STORAGE_SUF } from "../constants"
import { setStorageVariable } from "../utils/storage"

const suffix = localStorage.getItem(STORAGE_SUF) || ""

export const systemLogin = async (
  username: string,
  password: string,
): Promise<Response> => {
  const response = await fetch(`${BASE_URL}/auth/login-${suffix}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ username, password }),
  })

  if (response.ok) {
    setStorageVariable(STORAGE_SESSION_ACTIVE, "true")
  }

  return response
}
